import { red } from "@material-ui/core/colors";
import { createTheme } from "@material-ui/core/styles";

const shared = {
  shape: {
    borderRadius: 8,
  },
  layout: {
    drawerWidth: 240,
  },
  typography: {
    fontFamily: [
      "Open Sans",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    subtitle1: {
      fontWeight: 500,
    },
    button: {
      fontWeight: 800,
    },
    body1: {
      fontSize: "0.9375rem",
    },
    body2: {
      fontSize: "0.9375rem",
    },
  },
};

const light = {
  ...shared,
  palette: {
    common: {
      black: "#222",
    },
    primary: {
      main: "#474eff",
    },
    secondary: {
      main: "#e45858",
    },
    error: {
      main: red.A400,
    },
    text: {
      primary: "#202124",
      secondary: "#20212480",
    },
    background: {
      default: "#f2f2f7",
      paper: "#ffffff",
      input: "#ffffff",
    },
    divider: "rgba(145, 158, 171, 0.4)",
  },
  overrides: {
    MuiFilledInput: {
      input: {
        borderRadius: "4px",
        background: "#f0f3f5",
      },
    },
    MuiButton: {
      root: {
        borderRadius: "4px",
        textTransform: "none",
      },
      contained: {
        boxShadow: "none",
        backgroundColor: "#e8edf4",
      },
      containedPrimary: {
        color: "#fff",
      },
    },
  },
};

const dark = {
  ...shared,
  palette: {
    type: "dark",
    primary: {
      main: "#6e75ff",
    },
    secondary: {
      main: "#e45858",
    },
    error: {
      main: red.A400,
    },
    background: {
      default: "#121212",
      paper: "#1e1e1e",
      input: "#2c2c2c",
    },
    divider: "rgba(255, 255, 255, 0.12)",
  },
  overrides: {
    MuiFilledInput: {
      input: {
        borderRadius: "4px",
        background: "#2c2c2c",
      },
    },
    MuiButton: {
      root: {
        borderRadius: "4px",
        textTransform: "none",
      },
      contained: {
        boxShadow: "none",
        backgroundColor: "#333",
      },
      containedPrimary: {
        color: "#fff",
      },
    },
  },
};

export const defaultTheme = createTheme(light);
export const darkTheme = createTheme(dark);
